import { getEasing } from '../../utils';
export default function create(options) {
  const duration = options.duration || 0;
  const delay = options.delay || 0;
  const easing = getEasing(options.easing || 'cubicInOut');
  return [{
    ...options,
    easing: 'linear',
    delay: 0,
    duration: duration + delay,
    keyframes: [{
      offset: 0,
      opacity: 1,
      easing
    }, {
      offset: 0.5 * (duration / (duration + delay || 1)),
      opacity: 0,
      easing
    }, {
      offset: duration / (duration + delay || 1),
      opacity: 1
    }, {
      offset: 1,
      opacity: 1
    }]
  }];
  /*
   *
   * * @keyframes <name> {
   *   0% {
   *     opacity: 1
   *   }
   *   <duration / (duration + delay) * 50%> {
   *      opacity: 0
   *   }
   *   <1 - delay / (duration + delay)> {
   *      opacity: 1
   *   }
   *  100% {
   *      opacity: 1
   *   }
   * }
   *
   * #target {
   *   animation: <name> <duration + delay> 0s linear infinite;
   * }
   */
}
//# sourceMappingURL=Flash.js.map